interface Auth0Options {
  clientId: string
  domain: string
  returnTo: string
  redirectUri: string
  audience: string
}

export function getOptions(location?: Location): Auth0Options {
  let hostname = ''
  let origin = ''

  if (location) {
    hostname = location.hostname
    origin = location.origin
  }

  const production = 'capo.dsplatform.nl'
  const options = {
    clientId: '5rUVtZ1go0R40fNsJQNGf6X0sU92x5Ud',
    domain: 'dspanalytics.eu.auth0.com',
    returnTo: origin + '/home',
    redirectUri: origin + '/callback',
    audience: 'https://capo.dsplatform.nl/rest',
  }

  if (hostname !== production) {
    options.clientId = 'jVG2koCpugAfabADcxwmg2fwdL7lTscq'
    options.domain = 'test-dspanalytics.eu.auth0.com'
  }

  return options
}

let auth0Options: Auth0Options

function getAuth0Options() {
  if (!auth0Options) {
    auth0Options = getOptions(window.location)
  }

  return auth0Options
}

export { getAuth0Options }
